// extracted by mini-css-extract-plugin
export default {"container":"Cards_container__Es2oH","search":"Cards_search__gpwjD"};